var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-accordion", attrs: { "aria-label": _vm.ariaLabel } },
    _vm._l(_vm.items, function(item, index) {
      return _c("li", { key: index, staticClass: "c-accordion__fold" }, [
        _c(
          "button",
          {
            staticClass: "c-accordion__label",
            attrs: {
              id: item.id,
              "aria-expanded": _vm.isExpanded(index) ? "true" : "false",
              "aria-controls": _vm.isExpanded(index) ? "content" + index : null,
              type: "button"
            },
            on: {
              click: function($event) {
                return _vm.toggleExpand(index, item.kundoId, item.title)
              }
            }
          },
          [
            _c(
              "span",
              {
                staticClass: "c-expand__icon",
                class: { "c-expand__rotate": _vm.isExpanded(index) }
              },
              [
                _vm.isExpanded(index)
                  ? _c("v-icon", { attrs: { name: "icon-open-circle" } })
                  : _c("v-icon", { attrs: { name: "icon-open-circle" } }),
                _vm._v(" "),
                _c("span", { staticClass: "t-visually-hidden" }, [
                  _vm._v(_vm._s(_vm.isExpanded(index) ? "Stäng" : "Öppna"))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "c-accordion__title",
              domProps: { innerHTML: _vm._s(decodeURIComponent(item.title)) }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isExpanded(index)
          ? _c(
              "div",
              {
                staticClass: "c-accordion__content",
                attrs: {
                  id: "content" + index,
                  "aria-hidden": !_vm.isExpanded(index) ? true : false,
                  "aria-labelledby": item.id
                }
              },
              [
                _c("div", { staticClass: "c-accordion__content-inner" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(decodeURIComponent(item.content))
                    }
                  }),
                  _vm._v(" "),
                  item.buttonUrl
                    ? _c(
                        "div",
                        {
                          staticClass: "c-accordion__button",
                          attrs: { tabindex: "0" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "c-button c-button--primary",
                              attrs: { href: item.buttonUrl }
                            },
                            [
                              _c("span", { staticClass: "c-button--right" }, [
                                _vm._v(_vm._s(item.buttonText))
                              ]),
                              _vm._v(" "),
                              _c("v-icon", {
                                attrs: { name: "icon-arrow", size: "xxs" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }